import PortalLayout from '../../shared/components/PortalLayout';
import RoleSummaryTab from './RoleSummaryTab';

export default function DashboardPage() {
  return (
    <PortalLayout activeModule="dashboard">
      <RoleSummaryTab />
    </PortalLayout>
  );
}
